import React from 'react'
import PropTypes from 'prop-types'
import { colours, sizes } from '@qflow/theme'

export function ResetFilters({
  size = sizes.LARGER,
  colour = colours.CORE_NAVY,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 39 39"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        d="M32.7902 5.62109H3.21074C2.22637 5.62109 1.61163 6.69386 2.10583 7.54967L11.4514 23.4363V33.1032C11.4514 33.8144 12.0219 34.389 12.729 34.389H23.2719C23.979 34.389 24.5496 33.8144 24.5496 33.1032V23.4363L33.8991 7.54967C34.3893 6.69386 33.7746 5.62109 32.7902 5.62109ZM21.6728 31.4961H14.3282V25.2282H21.6768V31.4961H21.6728ZM22.0585 21.9898L21.6768 22.6568H14.3241L13.9424 21.9898L5.97503 8.51395H30.0259L22.0585 21.9898Z"
        fill={colour}
      />
      <circle cx="29" cy="10" r="10" fill="white" />
      <circle cx="29" cy="10" r="5" fill="white" />
      <path
        d="M28.875 2C24.5262 2 21 5.52617 21 9.875C21 14.2238 24.5262 17.75 28.875 17.75C33.2238 17.75 36.75 14.2238 36.75 9.875C36.75 5.52617 33.2238 2 28.875 2ZM31.7824 12.8668L30.6223 12.8615L28.875 10.7785L27.1295 12.8598L25.9676 12.865C25.8902 12.865 25.827 12.8035 25.827 12.7244C25.827 12.691 25.8393 12.6594 25.8604 12.633L28.1473 9.9084L25.8604 7.18555C25.8391 7.15978 25.8273 7.12753 25.827 7.09414C25.827 7.0168 25.8902 6.95352 25.9676 6.95352L27.1295 6.95879L28.875 9.0418L30.6205 6.96055L31.7807 6.95527C31.858 6.95527 31.9213 7.0168 31.9213 7.0959C31.9213 7.1293 31.909 7.16094 31.8879 7.1873L29.6045 9.91016L31.8896 12.6348C31.9107 12.6611 31.923 12.6928 31.923 12.7262C31.923 12.8035 31.8598 12.8668 31.7824 12.8668Z"
        fill={colour}
      />
    </svg>
  )
}

ResetFilters.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
